<template>
  <AdminLayout>
    <Head title="Demand Transfers" />

    <div class="headline flex flex-col md:flex-row justify-between items-start md:items-center mx-4 sm:mx-12">
      <h2 class="text-2xl font-semibold text-blue-600">Demand Transfers</h2>

      <div class="relative inline-flex self-start my-5">
        <div class="input-group">
          <select
            v-model="form.origin_id"
            id="origin_id"
            class="bg-gray-100"
          >
            <option :value="null">Select Origin</option>
            <option
              v-for="location in locations.data"
              :key="location.id"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select>
        </div>

        <div class="input-group ml-2">
          <select
            v-model="form.destination_id"
            id="destination_id"
            class="bg-gray-100"
          >
            <option :value="null">Select Destination</option>
            <option
              v-for="location in locations.data"
              :key="location.id"
              :value="location.id"
            >
              {{ location.name }}
            </option>
          </select>
        </div>

        <div class="input-group ml-2">
          <select
            v-model="form.range"
            class="bg-gray-100"
          >
            <option
              v-for="(value, key) in ranges"
              :key="key"
              :value="key"
            >
              {{ value }}
            </option>
          </select>
        </div>

        <div
          v-if="form.range === 'custom'"
          class="ml-2"
        >
          <div class="input-group">
            <date-range-picker
              v-model:start="form.start"
              v-model:end="form.end"
            />
          </div>
        </div>

        <div
          v-if="selected.length > 0"
          class="ml-2"
        >
          <button
            @click="openCreate()"
            type="button"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
          >
            Create Transfer
          </button>
        </div>
      </div>
    </div>

    <!-- Index table -->
    <div class="flex-1 bg-gray-100">
      <data-table
        :items="packages.data"
        :headers="headers"
        :actions="[]"
        v-model="selected"
      >
        <template v-slot:rows="slotRow">
          <index-row
            v-slot:rows="slotRow"
            v-bind="slotRow"
          />
        </template>
      </data-table>
    </div>

    <template #modals>
      <CreateModal
        v-model:open="showingCreateModal"
        :transfer-type="'demand'"
        :locations="locations.data"
        :spaces="spaces.data"
        :origin-id="selectedOriginId"
        :destination-id="selectedDestinationId"
        :packages="selectedPackages"
        :order-items="selectedOrderItemIds"
        @created="transferCreated()"
      />
    </template>
  </AdminLayout>
</template>

<style scoped></style>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'
import _datetime from '@/Filters/DateTime'
import accessesCompany from '@/Mixins/accessesCompany'
import DataTable from '@/Components/Table/DataTable'
import IndexRow from '@/Pages/Transfers/Demand/Components/IndexRow'
import CreateModal from '@/Pages/Transfers/Components/SubLot/CreateModal'
import DateRangePicker from '@/Components/Forms/DateRangePicker'

export default {
  mixins: [accessesCompany],

  components: {
    AdminLayout,
    Head,
    Link,
    DateRangePicker,
    DataTable,
    IndexRow,
    CreateModal
  },

  props: {
    packages: {
      type: Object,
      required: true
    },
    locations: {
      type: Object,
      required: true
    },
    spaces: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    ranges: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      showingCreateModal: false,
      form: this.$inertia.form(this.params),
      selected: []
    }
  },

  computed: {
    headers() {
      return ['Product', 'Origin', 'Destination', 'Orders', 'Transferred', 'Demand', 'Available']
    },
    selectedPackages() {
      console.log('this.selected', this.selected)
      return this.selected.map((item) => {
        return {
          details: {
            name: item.package.details.name,
            tag_num: item.package.details.tag_num,
            batch_num: item.package.details.batch_num
          },
          parent_id: item.package.id,
          quantity: item.demand,
          quantity_pre_reserved: item.demand,
          sub_lot_num: item.package.sub_lot_num,
          parent_sub_lot_num: null,
          product_name: item.package.product_name
        }
      })
    },
    selectedOriginId() {
      return this.selected.reduce((locationId, item) => {
        return locationId || item.origin.id
      }, null)
    },
    selectedDestinationId() {
      return this.selected.reduce((locationId, item) => {
        return locationId || item.destination.id
      }, null)
    },
    selectedOrderItemIds() {
      return _.uniq(
        this.selected.reduce((orderItemIds, item) => {
          return orderItemIds.concat(item.order_items)
        }, [])
      )
    }
  },

  watch: {
    'form.origin_id': function (newVal, oldVal) {
      this.reload()
    },
    'form.destination_id': function (newVal, oldVal) {
      this.reload()
    },
    'form.range': function (newVal, oldVal) {
      if (newVal !== 'custom') {
        this.form.start = this.form.end = null
        this.reload()
      }
    },
    'form.start': function (newVal, oldVal) {
      if (this.form.start && this.form.end) {
        this.reload()
      }
    },
    'form.end': function (newVal, oldVal) {
      if (this.form.start && this.form.end) {
        this.reload()
      }
    }
  },

  methods: {
    _datetime,
    reload() {
      this.form.get(route('transfers.demand.index'))
    },
    openCreate() {
      this.showingCreateModal = true
    },
    transferCreated() {
      this.showingCreateModal = false
      this.reload()
    }
  }
}
</script>
